import { ActionTypes } from "@/App/constants/actionTypes";
import { Action } from "@/App/actions";
import { ClaimTypes } from "@/types";

export interface ClaimSearchState {
  claimSearchOptions: ClaimTypes.ClaimSearchOptions;
  claimSearchResults: {
    results: Array<ClaimTypes.ClaimSearchResult>;
    result_count: string;
  };
  selectedClaim: ClaimTypes.Claim;
}

const defaultSelectedClaim: ClaimTypes.Claim = {
  id: null,
  first_name: " ",
  last_name: " ",
  external_member_id: " ",
  date_of_birth: null,
  patient_gender_code: " ",
  external_group_id: " ",
  group_name: " ",
  prescription_service_reference_number: " ",
  product_service_description: " ",
  strength: null,
  strength_unit_of_measure: " ",
  date_of_service: null,
  dosage_form: " ",
  transaction_response_status: " ",
  daw: " ",
  claim_submission_date: null,
  quantity_dispensed: null,
  service_provider_id: " ",
  days_supply: null,
  prescriber_id: " ",
  ndc: " ",
  programs: null,
};

const DEFAULT_CLAIM_SEARCH_STATE: ClaimSearchState = {
  claimSearchOptions: {
    full_text_search: "",
    order_by: [],
    page_number: 1,
    results_per_page: 20,
  },
  claimSearchResults: {
    results: [],
    result_count: "0",
  },
  selectedClaim: defaultSelectedClaim,
};

export default (state: ClaimSearchState = DEFAULT_CLAIM_SEARCH_STATE, action: Action): object => {
  if (action.type === ActionTypes.SEARCH_FOR_CLAIM_RESULTS) {
    return {
      ...state,
      claimSearchResults: action.payload,
    };
  } else if (action.type === ActionTypes.GET_CLAIM_RESULTS) {
    return {
      ...state,
      selectedClaim: action.payload,
    };
  } else if (action.type === ActionTypes.SEARCH_FOR_CLAIM) {
    return {
      ...state,
      claimSearchOptions: action.payload,
    };
  } else {
    return state;
  }
};
